module.exports = __webpack_public_path__ + "static/media/flexable-2.8355cd07.png";